import type { camera as getCamera } from '@/services/map-service'

/** Formats the current map camera (zoom, pitch, bearing, center) for the model. */
export const formatCamera = (
  camera: NonNullable<ReturnType<typeof getCamera>>
): string =>
  `map camera: zoom: ${camera.location.height} | pitch: ${camera.pitch} | bearing: ${camera.bearing} | center: [${camera.location.longitude}, ${camera.location.latitude}]`
